export default "__VITE_ASSET__CeJnPL5Z__"